import clonedeep from "lodash.clonedeep";

import { SportEvent, Option, Links, Offer } from "@fresh8/types/lib/betData";

function addKeyValue(link: string, key: string, value: string) {
  if (!link) return "";

  if (link.includes("?")) {
    return `${link}&${key}=${encodeURIComponent(value)}`;
  }

  return `${link}?${key}=${encodeURIComponent(value)}`;
}

const searchParams = new URLSearchParams(window.location.search);

export function links(
  links: Links,
  {
    clickUrl,
    targetUrl,
    affiliateId
  }: {
    clickUrl?: string;
    targetUrl?: string;
    affiliateId?: string;
  }
) {
  const trackingID = searchParams.get("trackingID") || undefined;

  return Object.keys(links).reduce(
    (updatedLinks, link) => {
      if (links[link] === "") {
        updatedLinks[link] = "";
        return updatedLinks;
      }

      if (clickUrl) {
        updatedLinks[link] = addKeyValue(
          updatedLinks[link],
          "clickUrl",
          clickUrl
        );
      }

      if (targetUrl) {
        updatedLinks[link] = addKeyValue(
          updatedLinks[link],
          "targetUrl",
          targetUrl
        );
      }

      if (affiliateId) {
        updatedLinks[link] = addKeyValue(
          updatedLinks[link],
          "affiliateId",
          affiliateId
        );
      }

      if (trackingID) {
        updatedLinks[link] = addKeyValue(
          updatedLinks[link],
          "externalId",
          trackingID
        );
      }

      return updatedLinks;
    },
    { ...links }
  );
}

export function option(option: Option, { clickUrl, targetUrl, affiliateId }) {
  const _option = clonedeep(option);
  const trackingID = searchParams.get("trackingID") || undefined;

  if (_option.betslipUrl) {
    if (clickUrl) {
      _option.betslipUrl = addKeyValue(
        _option.betslipUrl,
        "clickUrl",
        clickUrl
      );
    }

    if (targetUrl) {
      _option.betslipUrl = addKeyValue(
        _option.betslipUrl,
        "targetUrl",
        targetUrl
      );
    }

    if (affiliateId) {
      _option.betslipUrl = addKeyValue(
        _option.betslipUrl,
        "affiliateId",
        affiliateId
      );
    }

    if (trackingID) {
      _option.betslipUrl = addKeyValue(
        _option.betslipUrl,
        "externalId",
        trackingID
      );
    }
  }

  return _option;
}

export function options(
  options: Record<string, Option>,
  { clickUrl, targetUrl, affiliateId }
): Record<string, Option> {
  return Object.keys(options).reduce((updatedOptions, optionId) => {
    if (
      typeof updatedOptions[optionId] !== "string" &&
      updatedOptions[optionId].betslipUrl
    ) {
      updatedOptions[optionId] = option(updatedOptions[optionId], {
        clickUrl,
        targetUrl,
        affiliateId
      });
    }

    return updatedOptions;
  }, clonedeep(options));
}

export function event(event: SportEvent, { clickUrl, targetUrl, affiliateId }) {
  const trackingID = searchParams.get("trackingID") || undefined;
  const _event = clonedeep(event);

  if (clickUrl) {
    _event.eventUrl = addKeyValue(_event.eventUrl, "clickUrl", clickUrl);
  }

  if (targetUrl) {
    _event.eventUrl = addKeyValue(_event.eventUrl, "targetUrl", targetUrl);
  }

  if (affiliateId) {
    _event.eventUrl = addKeyValue(_event.eventUrl, "affiliateId", affiliateId);
  }

  if (trackingID) {
    _event.eventUrl = addKeyValue(_event.eventUrl, "externalId", trackingID);
  }

  return _event;
}

export function events(
  events: Record<string, SportEvent>,
  { clickUrl, targetUrl, affiliateId }
): Record<string, SportEvent> {
  return (
    events &&
    Object.keys(events).reduce((updatedOptions, eventId) => {
      if (
        typeof updatedOptions[eventId] !== "string" &&
        updatedOptions[eventId].eventUrl
      ) {
        updatedOptions[eventId] = event(updatedOptions[eventId], {
          clickUrl,
          targetUrl,
          affiliateId
        });
      }

      return updatedOptions;
    }, clonedeep(events))
  );
}

export function offer(offer: Offer, { affiliateId }): Offer {
  const targetUrl = offer.link;
  const trackingID = searchParams.get("trackingID") || undefined;
  const clickUrl = searchParams.get("clickUrl") || undefined;
  const _offer = clonedeep(offer);

  _offer.link = "https://links.fresh8.co";

  if (clickUrl) {
    _offer.link = addKeyValue(_offer.link, "clickUrl", clickUrl);
  }

  if (targetUrl) {
    _offer.link = addKeyValue(_offer.link, "targetUrl", targetUrl);
  }

  if (affiliateId) {
    _offer.link = addKeyValue(_offer.link, "affiliateId", affiliateId);
  }

  if (trackingID) {
    _offer.link = addKeyValue(_offer.link, "externalId", trackingID);
  }
  return _offer;
}
